import { NAVIGATION_ROUTE_TYPES, REFERENCE_GROUP_KEYS, COMPANY_REFERENCE_MATERIALS_NAMES } from './routerMapConfig'

const INFRASTRUCTURES_GROUP_PAGES = [
	{
		path: 'infrastructure-types',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.INFRASTRUCTURE__GROUPS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsInfrastructureTypesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.INFRASTRUCTURE,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.infrastructureTypes',
			isDynamicComponent: true,
		},
	},
	{
		path: 'infrastructure-tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.INFRASTRUCTURE__TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsInfrastructureTagsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.INFRASTRUCTURE,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.infrastructureTags',
			isDynamicComponent: true,
		},
	},
]

const STAFF_DEPARTMENTS_GROUP_PAGES = [
	{
		path: 'staff',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__LIST,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsStaffView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.STAFF_DEPARTMENTS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.Staff',
			isDynamicComponent: true,
		},
	},
	{
		path: 'staff-departments',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__DEPARTMENTS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsStaffDepartmentsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.STAFF_DEPARTMENTS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.staffDepartments',
			isDynamicComponent: true,
		},
	},
	{
		path: 'staff-groups',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__GROUPS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsStaffGroupsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.STAFF_DEPARTMENTS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.staffGroups',
			isDynamicComponent: true,
		},
	},
	{
		path: 'staff-roles',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__ROLES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsStaffRolesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.STAFF_DEPARTMENTS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.staffRoles',
			isDynamicComponent: true,
		},
	},
	{
		path: 'work_shifts',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.STAFF__WORKS_SHIFTS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksShiftsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.STAFF_DEPARTMENTS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksShifts',
			isDynamicComponent: true,
		},
	},
]

const RESOURCES_GROUP_PAGES = [
	{
		path: 'resources',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__LIST,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsResourcesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.RESOURCES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.resources',
			isDynamicComponent: true,
		},
	},
	{
		path: 'materials-categories',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__MATERIALS_CATEGORIES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsMaterialsCategoryView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.RESOURCES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.materialsCategories',
			isDynamicComponent: true,
		},
	},
	{
		path: 'materials-tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__MATERIALS_TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsMaterialsTagsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.RESOURCES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.materialsTags',
			isDynamicComponent: true,
		},
	},
	{
		path: 'cargo-tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.RESOURCES__CARGO_TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsCargoTagsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.RESOURCES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.cargoTags',
			isDynamicComponent: true,
		},
	},
]

const CAR_PARK_GROUP_PAGES = [
	{
		path: 'machines-groups',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.CAR_PARK__MACHINES_GROUPS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsMachinesGroupsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.CAR_PARK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.machinesGroups',
			isDynamicComponent: true,
		},
	},
	{
		path: 'equipment-groups',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.CAR_PARK__EQUIPMENT_GROUPS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsEquipmentGroupsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.CAR_PARK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.equipmentGroups',
			isDynamicComponent: true,
		},
	},
	{
		path: 'logistic-route-tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.CAR_PARK__LOGISTIC_ROUTE_TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsLogisticRouteTagsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.CAR_PARK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.logisticRouteTags',
			isDynamicComponent: true,
		},
	},
]

const COUNTERPARTIES_GROUP_PAGES = [
	{
		path: 'counterparties',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.COUNTERPARTIES__LIST,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsCounterpartiesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.COUNTERPARTIES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.counterparties',
			isDynamicComponent: true,
		},
	},
	{
		path: 'counterparties-groups',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.COUNTERPARTIES__GROUPS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsCounterpartiesGroupsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.COUNTERPARTIES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.counterpartiesGroups',
			isDynamicComponent: true,
		},
	},
]

const NORMS_GROUP_PAGES = [
	{
		path: 'works-service-payment-rate-norms',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__SERVICE_PAYMENT,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksServicePaymentRatesNormsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.NORMS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksServicePaymentRatesNorms',
			isDynamicComponent: true,
		},
	},
	{
		path: 'works-material-production-rate-norms',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__MATERIAL_PRODUCTION,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksMaterialProductionRateNormsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.NORMS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksMaterialProductionRateNorms',
			isDynamicComponent: true,
		},
	},
	{
		path: 'works-material-consumption-rate-norms',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__MATERIAL_CONSUMPTIONS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksMaterialConsumptionsRateNormsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.NORMS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksMaterialConsumptionRateNorms',
			isDynamicComponent: true,
		},
	},
	{
		path: 'works_staff_payment_rates_norms',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__STAFF_PAYMENT,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksStaffPaymentRatesNormsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.NORMS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksStaffPaymentRatesNorms',
			isDynamicComponent: true,
		},
	},
	{
		path: 'works-productivity-norms',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__PRODUCTIVITY,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksProductivityNormsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.NORMS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksProductivityNorms',
			isDynamicComponent: true,
		},
	},
	{
		path: 'works_quality_norms',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.NORMS__QUALITY,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksQualityNormsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.NORMS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksQualityNorms',
			isDynamicComponent: true,
		},
	},
]

const LAND_BANK = [
	{
		path: 'fields-tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__FIELD_TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsFieldsTagsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.LAND_BANK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.fieldsTags',
			isDynamicComponent: true,
		},
	},
	{
		path: 'land-purposes',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_PURPOSES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsLandPurposesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.LAND_BANK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.landPurposes',
			isDynamicComponent: true,
		},
	},
	{
		path: 'land-ownership-types',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_OWNERSHIP_TYPES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsLandOwnershipTypesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.LAND_BANK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.landOwnershipTypes',
			isDynamicComponent: true,
		},
	},
	{
		path: 'land-categories',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_CATEGORIES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsLandCategoriesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.LAND_BANK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.landCategories',
			isDynamicComponent: true,
		},
	},
	{
		path: 'land-actions',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_ACTIONS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsLandActionsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.LAND_BANK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.landActions',
			isDynamicComponent: true,
		},
	},
	{
		path: 'land-document-types',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.LAND_BANK__LAND_DOCUMENT_TYPES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsLandDocumentTypesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.LAND_BANK,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.landDocumentTypes',
			isDynamicComponent: true,
		},
	},
]

const FINANCES_GROUP_PAGES = [
	{
		path: 'finance_categories',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.FINANCE__CATEGORIES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsFinanceCategoriesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.FINANCES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.financeCategories',
			isDynamicComponent: true,
		},
	},
	{
		path: 'finance_groups',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.FINANCE__GROUPS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsFinanceGroupsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.FINANCES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.financeGroups',
			isDynamicComponent: true,
		},
	},
	{
		path: 'finance_tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.FINANCE__TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsFinanceTagsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.FINANCES,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.financeTags',
			isDynamicComponent: true,
		},
	},
]

const WORKS_GROUP_PAGES = [
	{
		path: 'works',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__LIST,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.works',
			isDynamicComponent: true,
		},
	},
	{
		path: 'works-categories',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__CATEGORIES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksCategoriesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksCategories',
			isDynamicComponent: true,
		},
	},
	{
		path: 'works-cost-categories',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__COST_CATEGORIES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorksCostCategoriesView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.worksCostCategories',
			isDynamicComponent: true,
		},
	},
	{
		path: 'work_report_links',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REPORT_LINK_TYPES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorkReportLinksView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.workReportLinks',
			isDynamicComponent: true,
		},
	},
	{
		path: 'work_report_measures',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__MEASURE_TYPES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorkReportMeasuresView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.workReportMeasures',
			isDynamicComponent: true,
		},
	},
	{
		path: 'work_report_photos',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REPORT_PHOTO_TYPES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorkReportPhotosView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.workReportPhotos',
			isDynamicComponent: true,
		},
	},
	{
		path: 'work-report-documents',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REPORT_DOCUMENT_TYPES,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsWorkReportDocumentsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.workDocumentsReport',
			isDynamicComponent: true,
		},
	},
	{
		path: 'regulation-tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REGULATION_TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsRegulationTags.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.regulationTags',
			isDynamicComponent: true,
		},
	},
	{
		path: 'regulations-stage-tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__REGULATION_STAGE_TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsRegulationsStageTagsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.regulationsStageTags',
			isDynamicComponent: true,
		},
	},
	{
		path: 'incident-tags',
		name: COMPANY_REFERENCE_MATERIALS_NAMES.WORKS__INCIDENT_TAGS,
		component: () =>
			import('@/views/company/reference-materials/CompanyReferenceMaterialsIncidentTagsGroupsView.vue'),
		meta: {
			categoryKey: REFERENCE_GROUP_KEYS.WORKS,
			navigationRouteType: NAVIGATION_ROUTE_TYPES.referenceMaterials.key,
			titleTranslationKey: 'menu.incidentTags',
			isDynamicComponent: true,
		},
	},
]

export const COMPANY_REFERENCE_MATERIALS_PAGES = [
	...INFRASTRUCTURES_GROUP_PAGES,
	...STAFF_DEPARTMENTS_GROUP_PAGES,
	...RESOURCES_GROUP_PAGES,
	...CAR_PARK_GROUP_PAGES,
	...COUNTERPARTIES_GROUP_PAGES,
	...NORMS_GROUP_PAGES,
	...LAND_BANK,
	...FINANCES_GROUP_PAGES,
	...WORKS_GROUP_PAGES,
]
